module.exports = __webpack_public_path__ + "img/home.6e666627.jpg";